module.exports = __webpack_public_path__ + "static/BT-mobile-16-edad5abccb7cc4199593abf998dd28a3.jpg";